// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16BEB","left":"styles_left__8PuIi"};